<template>
  <div>
    <v-form
      ref="form"
      method="GET"
      action="https://api.cryptonator.com/api/merchant/v1/startpayment"
      target="_blank"
    >
      <input
        type="hidden"
        name="merchant_id"
        value="fffced9276c73958a33ebc8fe2be3141"
      >
      <input
        type="hidden"
        name="item_name"
        value="AIVIA Services"
      >
      <input
        type="hidden"
        name="item_description"
        value=""
      >
      <input
        type="hidden"
        name="order_id"
        :value="invoice.id"
      >
      <input
        type="hidden"
        name="invoice_currency"
        :value="currency"
      >
      <input
        type="hidden"
        name="invoice_amount"
        :value="invoice.total"
        data-type="number"
      >
      <input
        type="hidden"
        name="language"
        :value="$i18n.locale"
      >
      <input
        type="hidden"
        name="success_url"
        value="https://app.aivia.io/invoices/success"
      >
      <input
        type="hidden"
        name="failed_url"
        value="https://app.aivia.io/invoices/failed"
      >
    </v-form>
    <v-layout
      wrap
      align-center
      mt-5
      mb-10
    >
      <v-flex
        xs12
        text-center
      >
        <v-progress-circular
          :size="40"
          color="primary"
          class="mb-2"
          indeterminate
        /><br>
        {{ $t('gateway.proceedGateway') }}
      </v-flex>
    </v-layout>
  </div>
</template>

<script>


export default {
  name: 'Cryptonator',
  props: {
    invoice: {
      type: Object,
      default() {
        return null
      }
    },
  },
  data() {
    return {
     loading: false
    }
  },
  computed: {
    currency() {
      let currency = null
      switch(this.invoice.currency) {
        case 'BTC':
          currency = 'bitcoin'
          break;
        case 'USDT':
          currency = 'usd'
          break;
        default:
          break;
      }
      return currency
    }
  },
  mounted() {
    this.$refs.form.$el.submit()
  }
}
</script>
<style lang="scss" scoped >

</style>
